// useContext
import { createContext, useState } from "react";

import Arigap from "../assets/image/AirGap.png"
import AlphaWallet from "../assets/image/alphawallet.png"
import ambire from "../assets/image/ambire.png"
import argent from "../assets/image/argent.png"
import bitcoin from "../assets/image/bitcoin.png"
import brave from "../assets/image/brave.png"
import CoinWallet from "../assets/image/coin.png"
import coinomi from "../assets/image/coinomi.webp"
import electrum from "../assets/image/electrum.webp"
import enkrypt from "../assets/image/enkrypt.jpg"
import frame from "../assets/image/frame.png"
import safe from "../assets/image/safe.png"
import loopring from "../assets/image/loopring.png"
import mewwallet from "../assets/image/mewwallet.png"
import metamask from "../assets/image/metamask.png"
import mycrypto from "../assets/image/mycrypto.png"
import myetherwallet from "../assets/image/myetherwallet.png"
import pillar from "../assets/image/pillar.png"
import rabby from "../assets/image/rabby.png"
import railway from "../assets/image/railway.png"
import rainbow from "../assets/image/rainbow.png"
import samouraiwallet from "../assets/image/samouraiwallet.png"
import sequence from "../assets/image/sequence.svg"
import sparrowwallet from "../assets/image/sparrowwallet.png"
import status from "../assets/image/status.webp"
import taho from "../assets/image/taho.png"
import trustwallet from "../assets/image/trustwallet.webp"
import unstoppable from "../assets/image/unstoppable.png"
import wasabiwallet from "../assets/image/wasabiwallet.jpg"
import web3auth from "../assets/image/web3auth.png"

export const DataContext = createContext();

export default function DataProvider(props) {
  const [data, setData] = useState([
    {
      id: 1,
      name: "AirGap",
      path: "/airgap",
      crypto: false,
      defi: true,
      hardware: true,
      hodl: false,
      nft: false,
      android: true,
      chrome: false,
      firefox: false,
      ios: true,
      linux: true,
      macos: true,
      website: false,
      windows: true,
      image: Arigap,
      url: "https://airgap.it/"
    },
    {
      id: 2,
      name: "AlphaWallet",
      path: "/alphawallet",
      crypto: true,
      defi: true,
      hardware: false,
      hodl: false,
      nft: true,
      android: true,
      chrome: false,
      firefox: false,
      ios: true,
      linux: false,
      macos: false,
      website: false,
      windows: false,
      image: AlphaWallet,
      url: "https://alphawallet.com/"
    },
    {
      id: 3,
      name: "Ambire",
      path: "/ambire",
      crypto: true,
      defi: true,
      hardware: true,
      hodl: false,
      nft: true,
      android: false,
      chrome: false,
      firefox: false,
      ios: false,
      linux: false,
      macos: false,
      website: true,
      windows: false,
      image: ambire,
      url: "https://www.ambire.com/"
    },
    {
      id: 4,
      name: "argent",
      path: "/argent",
      crypto: true,
      defi: true,
      hardware: true,
      hodl: false,
      nft: true,
      android: true,
      chrome: true,
      firefox: true,
      ios: true,
      linux: false,
      macos: false,
      website: false,
      windows: false,
      image: argent,
      url: "https://www.argent.xyz/"
    },
    {
      id: 5,
      name: "bitcoin",
      path: "/bitcoin",
      crypto: false,
      defi: false,
      hardware: true,
      hodl: true,
      nft: false,
      android: false,
      chrome: false,
      firefox: false,
      ios: false,
      linux: true,
      macos: true,
      website: false,
      windows: true,
      image: bitcoin,
      url: "https://bitcoin.org/en/"
    },
    {
      id: 6,
      name: "Brave",
      path: "/brave",
      crypto: true,
      defi: true,
      hardware: true,
      hodl: false,
      nft: true,
      android: true,
      chrome: true,
      firefox: false,
      ios: true,
      linux: false,
      macos: false,
      website: false,
      windows: false,
      image: brave,
      url: "https://brave.com/wallet/"
    },
    {
      id: 7,
      name: "Coin Wallet",
      path: "/coinwallet",
      crypto: true,
      defi: false,
      hardware: false,
      hodl: true,
      nft: false,
      android: true,
      chrome: false,
      firefox: false,
      ios: true,
      linux: true,
      macos: true,
      website: false,
      windows: true,
      image: CoinWallet,
      url: "https://coin.space/"
    },
    {
      id: 8,
      name: "coinomi",
      path: "/coinomi",
      crypto: true,
      defi: true,
      hardware: true,
      hodl: false,
      nft: true,
      android: true,
      chrome: false,
      firefox: false,
      ios: true,
      linux: true,
      macos: true,
      website: false,
      windows: true,
      image: coinomi,
      url: "https://www.coinomi.com/en/"
    },
    {
      id: 9,
      name: "Electrum",
      path: "/electrum",
      crypto: false,
      defi: false,
      hardware: true,
      hodl: true,
      nft: false,
      android: true,
      chrome: false,
      firefox: false,
      ios: false,
      linux: true,
      macos: true,
      website: false,
      windows: true,
      image: electrum,
      url: "https://electrum.org/#home"
    },
    {
      id: 10,
      name: "Enkrypt",
      path: "/enkrypt",
      crypto: true,
      defi: true,
      hardware: true,
      hodl: false,
      nft: true,
      android: false,
      chrome: true,
      firefox: true,
      ios: false,
      linux: false,
      macos: false,
      website: false,
      windows: false,
      image: enkrypt,
      url: "https://www.enkrypt.com/"
    },
    {
      id: 11,
      name: "Frame",
      path: "/frame",
      crypto: false,
      defi: true,
      hardware: true,
      hodl: false,
      nft: true,
      android: false,
      chrome: true,
      firefox: false,
      ios: false,
      linux: true,
      macos: true,
      website: false,
      windows: true,
      image: frame,
      url: "https://frame.sh/"
    },
    {
      id: 12,
      name: "Safe",
      path: "/safe",
      crypto: true,
      defi: true,
      hardware: true,
      hodl: false,
      nft: true,
      android: true,
      chrome: false,
      firefox: false,
      ios: true,
      linux: true,
      macos: true,
      website: false,
      windows: true,
      image: safe,
      url: "https://safe.global/"
    },
    {
      id: 13,
      name: "Loopring",
      path: "/loopring",
      crypto: true,
      defi: false,
      hardware: true,
      hodl: false,
      nft: true,
      android: true,
      chrome: false,
      firefox: false,
      ios: true,
      linux: false,
      macos: false,
      website: false,
      windows: false,
      image: loopring,
      url: "https://loopring.io/#/wallet"
    },
    {
      id: 14,
      name: "MEWwallet",
      path: "/mewwallet",
      crypto: true,
      defi: true,
      hardware: false,
      hodl: false,
      nft: false,
      android: true,
      chrome: false,
      firefox: false,
      ios: true,
      linux: false,
      macos: false,
      website: false,
      windows: false,
      image: mewwallet,
      url: "https://www.mewwallet.com/"
    },
    {
      id: 15,
      name: "MetaMask",
      path: "/metamask",
      crypto: true,
      defi: true,
      hardware: true,
      hodl: true,
      nft: true,
      android: true,
      chrome: true,
      firefox: true,
      ios: true,
      linux: false,
      macos: false,
      website: false,
      windows: false,
      image: metamask,
      url: "https://metamask.io/"
    },
    {
      id: 16,
      name: "MyCrypto",
      path: "/mycrypto",
      crypto: true,
      defi: false,
      hardware: true,
      hodl: true,
      nft: true,
      android: true,
      chrome: false,
      firefox: false,
      ios: false,
      linux: true,
      macos: true,
      website: false,
      windows: true,
      image: mycrypto,
      url: "https://mycrypto.com/"
    },
    {
      id: 17,
      name: "MyEtherWallet",
      path: "/myetherwallet",
      crypto: true,
      defi: true,
      hardware: true,
      hodl: true,
      nft: true,
      android: true,
      chrome: true,
      firefox: false,
      ios: true,
      linux: false,
      macos: false,
      website: false,
      windows: false,
      image: myetherwallet,
      url: "https://www.myetherwallet.com/"
    },
    {
      id: 18,
      name: "Pillar",
      path: "/pillar",
      crypto: true,
      defi: true,
      hardware: false,
      hodl: true,
      nft: false,
      android: true,
      chrome: false,
      firefox: false,
      ios: true,
      linux: false,
      macos: false,
      website: false,
      windows: false,
      image: pillar,
      url: "https://www.pillar.fi/"
    },
    {
      id: 19,
      name: "Rabby",
      path: "/rabby",
      crypto: true,
      defi: true,
      hardware: false,
      hodl: false,
      nft: false,
      android: false,
      chrome: true,
      firefox: false,
      ios: false,
      linux: false,
      macos: false,
      website: false,
      windows: false,
      image: rabby,
      url: "https://rabby.io/"
    },
    {
      id: 20,
      name: "Railway",
      path: "/railway",
      crypto: false,
      defi: false,
      hardware: false,
      hodl: false,
      nft: false,
      android: false,
      chrome: false,
      firefox: false,
      ios: false,
      linux: true,
      macos: true,
      website: true,
      windows: true,
      image: railway,
      url: "https://railway.xyz/"
    },
    {
      id: 21,
      name: "Rainbow",
      path: "/rainbow",
      crypto: true,
      defi: true,
      hardware: false,
      hodl: false,
      nft: true,
      android: true,
      chrome: false,
      firefox: false,
      ios: true,
      linux: false,
      macos: false,
      website: false,
      windows: false,
      image: rainbow,
      url: "https://rainbow.me/"
    },
    {
      id: 22,
      name: "Samourai",
      path: "/samourai",
      crypto: true,
      defi: false,
      hardware: false,
      hodl: false,
      nft: false,
      android: true,
      chrome: false,
      firefox: false,
      ios: false,
      linux: false,
      macos: false,
      website: false,
      windows: false,
      image: samouraiwallet,
      url: "https://samouraiwallet.com/"
    },
    {
      id: 23,
      name: "Sequence",
      path: "/sequence",
      crypto: true,
      defi: false,
      hardware: false,
      hodl: false,
      nft: false,
      android: false,
      chrome: false,
      firefox: false,
      ios: false,
      linux: false,
      macos: false,
      website: false,
      windows: false,
      image: sequence,
      url: "https://sequence.xyz/"
    },
    {
      id: 24,
      name: "Sparrow",
      path: "/sparrow",
      crypto: true,
      defi: false,
      hardware: false,
      hodl: false,
      nft: false,
      android: false,
      chrome: false,
      firefox: false,
      ios: false,
      linux: true,
      macos: true,
      website: false,
      windows: true,
      image: sparrowwallet,
      url: "https://sparrowwallet.com/"
    },
    {
      id: 25,
      name: "status",
      path: "/status",
      crypto: true,
      defi: false,
      hardware: false,
      hodl: false,
      nft: true,
      android: true,
      chrome: false,
      firefox: false,
      ios: true,
      linux: false,
      macos: false,
      website: false,
      windows: false,
      image: status,
      url: "https://status.im/"

    },
    {
      id: 26,
      name: "Taho",
      path: "/taho",
      crypto: true,
      defi: true,
      hardware: false,
      hodl: false,
      nft: true,
      android: false,
      chrome: true,
      firefox: false,
      ios: false,
      linux: false,
      macos: false,
      website: false,
      windows: false,
      image: taho,
      url: "https://taho.xyz/"
    },
    {
      id: 27,
      name: "Trust Wallet",
      path: "/trustwallet",
      crypto: true,
      defi: true,
      hardware: false,
      hodl: false,
      nft: true,
      android: true,
      chrome: false,
      firefox: false,
      ios: true,
      linux: false,
      macos: false,
      website: false,
      windows: false,
      image: trustwallet,
      url: "https://trustwallet.com/"
    },
    {
      id: 28,
      name: "Unstoppable",
      path: "/unstoppable",
      crypto: true,
      defi: false,
      hardware: false,
      hodl: false,
      nft: true,
      android: false,
      chrome: false,
      firefox: false,
      ios: false,
      linux: false,
      macos: false,
      website: false,
      windows: false,
      image: unstoppable,
      url: "https://unstoppable.money/"
    },
    {
      id: 29,
      name: "Wasabi Wallet",
      path: "/wasabiwallet",
      crypto: true,
      defi: false,
      hardware: false,
      hodl: false,
      nft: false,
      android: false,
      chrome: false,
      firefox: false,
      ios: false,
      linux: true,
      macos: true,
      website: false,
      windows: true,
      image: wasabiwallet,
      url: "https://wasabiwallet.io/"
    },
    {
      id: 30,
      name: "Web3Auth",
      path: "/web3auth",
      crypto: false,
      defi: false,
      hardware: false,
      hodl: false,
      nft: false,
      android: true,
      chrome: true,
      firefox: true,
      ios: true,
      linux: false,
      macos: true,
      website: false,
      windows: true,
      image: web3auth,
      url: "https://web3auth.io/"
    },
  ]);

  return (
    <DataContext.Provider value={data}>{props.children}</DataContext.Provider>
  );
}
